/**
 * MOBILE HERO — two intro pieces:
 *
 *  - `HeroMobileIntro`: centered H1 (platform claim) + subhead + "Demo buchen →" primary button.
 *  - `HeroMobileClosingCta`: the closing dark CTA panel.
 *
 * Both are mobile-width specific (paddings + vertical button stack), so they do
 * NOT reuse the full-width desktop `HeroCta`.
 */
import Link from "next/link";
import type { ReactNode } from "react";

import { useTranslations } from "next-intl";
import { H, MOBILE_HERO_BAND_GUTTER } from "./hero-tokens";
import { HeroCtaPanel, heroCtaEmphasis } from "./sections/hero-cta-panel";

/** SECTION 2 — hero copy + stacked button column. */
export function HeroMobileIntro(): ReactNode {
  const t = useTranslations("marketing.heroMobileCta");
  const tIntro = useTranslations("marketing.heroIntro");
  return (
    <div style={{ textAlign: "center", padding: "40px 28px 0" }}>
      <h1
        style={{
          fontFamily: H.display,
          fontWeight: 400,
          fontSize: 34,
          lineHeight: 1.1,
          letterSpacing: "-0.016em",
          color: H.ink,
          margin: "0 auto",
          maxWidth: "100%",
          padding: "0 4px",
        }}
      >
        {t("plattformHeadline")}
      </h1>

      <p className="mkhero-lead" style={{ color: H.inkMute }}>
        {tIntro("einstieg")}
      </p>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          marginTop: 24,
        }}
      >
        <Link
          href="/demo"
          className="mkhero-ctabtn"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 9,
            background: H.ctaGradient,
            color: "#fff",
            padding: "14px 26px",
            borderRadius: 12,
            fontSize: 16,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          {t("demoBuchen")}
        </Link>
      </div>
    </div>
  );
}

/** SECTION 6 — closing dark CTA card. */
export function HeroMobileClosingCta(): ReactNode {
  const t = useTranslations("marketing.heroMobileCta");
  return (
    <div
      style={{
        margin: "40px auto 0",
        padding: `0 ${MOBILE_HERO_BAND_GUTTER}px`,
      }}
    >
      <HeroCtaPanel
        compact
        headline={t.rich("siehWieVielLeichter", { em: heroCtaEmphasis })}
        sub={null}
        buttonLabel={t("demoCallBuchen")}
      />
    </div>
  );
}
